export default {
	game: {
		maintenance: 'مرمت جاری ہے',
		maintenance_tip: 'عارضی طور پر دستیاب نہیں',
		no_more_data: 'مزید ڈیٹا نہیں',
		search_game_name: 'گیم کا نام تلاش کریں...',
		selected: 'منتخب شدہ',
		type: 'قسم',
		all_types: 'تمام اقسام',
		secondary: 'ثانوی',
		secondary_category: 'ثانوی زمرہ',
		no_related_games: 'کوئی متعلقہ گیم نہیں ملا',
		reset_all: 'سب ری سیٹ کریں',
		end_of_list: 'فہرست کا اختتام',
		game_details: 'گیم کی تفصیلات',
		play: 'کھیلیں',
		bonus_cannot_wagered: 'بونس پر شرط نہیں لگائی جا سکتی',
		entering_game: 'گیم میں داخل ہو رہے ہیں، براہ مہربانی انتظار کریں...',
		entering_game_short: 'گیم میں داخل ہو رہے ہیں...',
		game_types: 'گیم کی اقسام',
		game_providers: 'گیم فراہم کرنے والے',
		sign_up: 'رجسٹر کریں',
		search: 'تلاش کریں',
		all_providers: 'تمام فراہم کرنے والے',
		loading: 'لوڈ ہو رہا ہے...',
		my_bet: 'میری شرط'
	}
};